import { Component, OnInit } from '@angular/core';

import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { DataService, HelperService, HTTPService } from 'app/services';
import { SwitchCorporateDialogComponent } from '../switch-corporate-dialog/switch-corporate-dialog.component';
import { Location } from '@angular/common';

@Component({
  

  selector: 'app-add-custom-overrides-dialog',
  templateUrl: './add-custom-overrides-dialog.component.html',
  styleUrls: ['./add-custom-overrides-dialog.component.scss'],
  providers: [DialogService],
})
export class AddCustomOverridesDialogComponent implements OnInit {
  customOverride: string = '';
  isUpdate = false;
  constructor(private helperService: HelperService, private dialogService: DialogService,
    private dialogConfig: DynamicDialogConfig, private dynamicDialogRef: DynamicDialogRef,
    private httpService: HTTPService, private dataService: DataService,private location: Location) { }

  ngOnInit() {
    const {customOverride, isUpdate } = this.dialogConfig.data
    this.customOverride = customOverride;
    this.isUpdate = isUpdate;
    }

  
  handleChange(event) {
    this.customOverride = event;
  }

  handleClose(isSuccess: boolean = false) {
    this.dynamicDialogRef.close({ isSuccess });
  }

  handleSave() {
    this.dynamicDialogRef.close({ isSuccess: true, data: this.customOverride });
  }

}
